import { render, staticRenderFns } from "./AliasForm.vue?vue&type=template&id=681ae76d&scoped=true"
import script from "./AliasForm.vue?vue&type=script&lang=js"
export * from "./AliasForm.vue?vue&type=script&lang=js"
import style0 from "./AliasForm.vue?vue&type=style&index=0&id=681ae76d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681ae76d",
  null
  
)

export default component.exports